export const initialValuesFirstStep = {
  dni: "",
  tipoMatricula: "",
  nroMatricula: "",
  provincia: "",
};
